import { Component, ElementRef, ViewChild } from '@angular/core'
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'
import { AuthManager } from './shared/auth/AuthManager'
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core'
import { Keepalive } from '@ng-idle/keepalive'
import { Title } from '@angular/platform-browser'
import { filter } from 'rxjs/operators'
import { MenuItem } from 'primeng/api'
import { environment } from 'src/environments/environment'

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss'],
   standalone: false,
})
export class AppComponent {
   title = 'Vetcor Apps'
   isLogin = true

   idleState = 'Not started.'
   timedOut = false
   lastPing?: Date = null

   areaName = ''

   home: MenuItem = { routerLink: '/', icon: 'fas fa-home' }
   menuItems: MenuItem[] = []

   @ViewChild('btnStay', { static: false })
   btnStay: ElementRef

   isAdmin: boolean = false
   isLoading: boolean = true
   showTimeoutModal = false
   readonly suggestionEmail = environment.suggestionEmail ?? 'apps@vetcor.com'
   readonly zohoHelpDeskUrl = environment.zohoHelpDeskUrl ?? 'https://forms.zohopublic.com/ernieturnervet1/form/LTKHelpdeskForm/formperma/6gKQQKMt0KIoczQ0fpZZd4c7k2mv1NSYAs0bqNNDo9c'

   constructor(
      private router: Router,
      private authService: AuthManager,
      private idle: Idle,
      keepalive: Keepalive,
      private activatedRoute: ActivatedRoute,
      private titleService: Title
   ) {
      idle.setIdle(30 * 60)
      idle.setTimeout(30)
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES)

      idle.onIdleEnd.subscribe(() => {
         this.idleState = 'No longer idle.'
         console.log(this.idleState)
         this.reset()
      })

      idle.onTimeout.subscribe(() => {
         this.showTimeoutModal = false
         this.idleState = 'Timed out!'
         this.timedOut = true
         console.log(this.idleState)
         this.logOut()
      })

      idle.onIdleStart.subscribe(() => {
         this.idleState = "You've gone idle!"
         console.log(this.idleState)
         this.showTimeoutModal = true
      })

      idle.onTimeoutWarning.subscribe((countdown) => {
         this.idleState = 'We will automatically log you out in ' + countdown + ' seconds.'
         console.log(this.idleState)
      })

      keepalive.interval(30)

      keepalive.onPing.subscribe(() => (this.lastPing = new Date()))
   }

   ngOnInit(): void {
      this.authService.getCurrentUser().subscribe((user) => {
         var adminRole = user.roles.find((x) => {
            return x.roleName == 'Admin'
         })
         if (adminRole) {
            this.isAdmin = true
         }
      })
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
         this.isLoading = false
         //this.menuItems = this.createBreadcrumbs(this.activatedRoute.root);

         if (event.url === '/login') {
            this.isLogin = true
            this.idle.stop()
         } else {
            this.isLogin = false
            this.idle.watch()
            this.timedOut = false
         }
         var route = this.activatedRoute.firstChild
         var areaName = route.snapshot.data['areaName']
         var url = ''
         this.menuItems = []
         while (route) {
            const routeURL: string = route.snapshot.url.map((segment) => segment.path).join('/')
            if (routeURL == '') {
               areaName = 'Hospital Workspace'
            } else if (routeURL !== '') {
               url += `/${routeURL}`
            }
            if (route.snapshot.data['areaName']) {
               areaName = route.snapshot.data['areaName']
            }
            if (route.snapshot.data['breadcrumb']) {
               this.menuItems.push({
                  label: route.snapshot.data['breadcrumb'],
                  routerLink: url,
               })
            }
            route = route.firstChild
         }
         this.areaName = areaName
         this.titleService.setTitle(this.areaName)
      })
   }

   onTimeoutShown() {
      this.btnStay.nativeElement.focus()
   }

   private createBreadcrumbs(route: ActivatedRoute, url: string = '#', breadcrumbs: MenuItem[] = []): MenuItem[] {
      const children: ActivatedRoute[] = route.children

      if (children.length === 0) {
         return breadcrumbs
      }

      for (const child of children) {
         const routeURL: string = child.snapshot.url.map((segment) => segment.path).join('/')
         if (routeURL !== '') {
            url += `/${routeURL}`
         }

         const label = child.snapshot.data['areaName']
         if (label) {
            breadcrumbs.push({ label, url })
         }

         return this.createBreadcrumbs(child, url, breadcrumbs)
      }
   }

   clearIdle() {
      this.reset()
      this.showTimeoutModal = false
   }

   reset() {
      this.showTimeoutModal = false
      this.idle.watch()
      this.timedOut = false
   }

   logOut() {
      this.showTimeoutModal = false
      this.authService.clearAndRedirect()
   }

   openSuggestionEmail() {
      const subject = encodeURIComponent('LTK Suggestion')
      window.location.href = `mailto:${this.suggestionEmail}?subject=${subject}`
   }

   openZohoHelpDesk() {
      window.open(this.zohoHelpDeskUrl, '_blank', 'noopener,noreferrer')
   }
}
